<template>
  <div class="baseParameters">
    <zm-label title="基本参数" />
    <div class="base-data">
      <a-form>
        <a-row style="width:100%" :gutter="10">
          <a-col :span="4" v-for="(item, index) in baseData" :key="index">
            <a-form-item>
              <a-input disabled :value="item.name" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <zm-label title="其他参数" />
    <div class="other-data">
      <div class="action-btn">
        <a-button class="btn" @click="cancel">取消</a-button>
        <a-button class="btn" type="primary" @click="save" :loading="btnLoading">保存</a-button>
      </div>
      <a-row style="width:100%" :gutter="10" class="item-label">
        <a-col :span="5">参数名称</a-col>
        <a-col :span="5">是否必填</a-col>
        <a-col :span="5">参数状态：在用/失效</a-col>
        <a-col :span="9">
          <span>填写类型</span>
          <a-tooltip placement="topLeft" title="选择单选时，用顿号分隔每个项点，如：A、B、C、D">
            <a-icon type="info-circle" theme="filled" />
          </a-tooltip>
        </a-col>
      </a-row>
      <a-row v-for="(item, index) in otherData" :key="index" :gutter="10" class="item-data">
        <a-col :span="5">
          <a-form-item>
            <a-input v-model="item.name" />
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item>
            <a-select v-model="item.requiredState" style="width: 100%">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item>
            <a-select v-model="item.status" style="width: 100%">
              <a-select-option :value="1">在用</a-select-option>
              <a-select-option :value="2">失效</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="9">
          <a-col :span="6">
            <a-form-item>
              <a-select v-model="item.valueType" style="width: 100%" @change="delete item.valueOptions">
                <a-select-option :value="1">填空</a-select-option>
                <a-select-option :value="2">单选</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="16">
            <a-form-item>
              <a-input :disabled="item.valueType === 1" v-model="item.valueOptions"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <a-form-item>
              <a-icon type="minus-circle" theme="filled" @click="remove(item, index)" />
            </a-form-item>
          </a-col>
        </a-col>
      </a-row>
      <a-button block type="dashed" icon="plus" @click="add">添加</a-button>
    </div>
  </div>
</template>

<script>
import { getEquipmentParameters, saveEquipmentParameters } from '@/api/equipmentParameters'

export default {
  props: {
    typeCode: String
  },
  watch: {
    typeCode: {
      handler () {
        this.initData()
      },
      immediate: true
    },
  },
  data () {
    return {
      btnLoading: false,
      baseData: [],
      otherData: []
    }
  },
  methods: {
    initData (typeCode) {
      // 获取设备参数信息
      getEquipmentParameters({ typeCode: this.typeCode }).then(res => {
        if (res.status === 0) {
          this.baseData = res.data.basic
          this.otherData = res.data.other.map(item => {
            item.requiredState = item.requiredState ? 1 : 0
            return item
          })
        }
      })
    },
    cancel () {
      this.initData()
    },
    save () {
      const { otherData } = this
      const data = []
      if (otherData.length > 0) {
        for (let i = 0; i < otherData.length; i++) {
          const item = otherData[i]

          if (!item.name || (item.valueType === 2 && !item.valueOptions)) {
            this.$message.warning(`请补充第${i + 1}条其他参数信息`)
            return
          }

          const obj = {
            typeCode: this.typeCode,
            name: item.name,
            basicState: false,
            requiredState: item.requiredState,
            status: item.status,
            valueType: item.valueType,
            valueOptions: item.valueOptions || ''
          }
          if (item.id) obj.id = item.id
          data.push(obj)
        }
      }
      console.log('save_data', data)
      this.btnLoading = true
      saveEquipmentParameters(data).then(res => {
        this.btnLoading = false
        if (res.status === 0) {
          this.$message.success('保存成功！')
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(() => {
        this.btnLoading = false
        this.$message.error('保存参数出错，请联系管理员')
      })
    },
    remove (item, index) {
      this.otherData.splice(index, 1)
    },
    add () {
      this.otherData.push({ requiredState: 0, status: 1, valueType: 1 })
    },
  }
}
</script>

<style lang="less" scoped>
.baseParameters{
  .zm-label{
    margin-bottom: 16px;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .other-data{
    position: relative;
    .action-btn{
      position: absolute;
      right: 10px;
      top: -36px;
      display: flex;
      .btn{
        margin-left: 10px;
      }
    }
    .item-label{
      margin-bottom: 10px;
      .anticon{
        color: #1791FF;
        font-size: 14px;
        margin-left: 6px;
      }
    }
    .item-data{
      width: 100%;
      .anticon{
        color: #E73B3B;
        font-size: 16px;
      }
    }
  }
}
</style>